import { useState } from 'react';
import { FiCheck, FiChevronDown, FiHome, FiPlus } from 'react-icons/fi';
import { useAuth } from '../../../contexts';
import { toast } from '../../ui';
import styles from './Header.module.css';

const ROTULO_DO_ESTADO = { suspensa: 'Suspensa', inativa: 'Inativa' } as const;

/**
 * Seletor de empresa (plano de convites, Fase 4). Aparece para quem participa
 * de mais de uma empresa, independente do plano: ninguem pode ficar preso numa
 * empresa de que so uma feature tiraria. Tambem aparece para quem so participa
 * de empresas de outros, porque e por aqui que se cria a propria.
 */
export function EmpresaSelector() {
    const { user, empresas, empresaAtiva, selecionarEmpresa, criarMinhaEmpresa, isAdmin } = useAuth();
    const [aberto, setAberto] = useState(false);
    const [confirmandoCriacao, setConfirmandoCriacao] = useState(false);
    const [criando, setCriando] = useState(false);

    const temPropria = empresas.some((e) => e.souDono);
    if (isAdmin || empresas.length === 0 || (empresas.length === 1 && temPropria)) return null;

    const fechar = () => {
        setAberto(false);
        setConfirmandoCriacao(false);
    };

    const criar = async () => {
        setCriando(true);
        try {
            await criarMinhaEmpresa();
            fechar();
        } catch (e) {
            toast(e instanceof Error ? e.message : 'Não foi possível criar a empresa', 'error');
        } finally {
            setCriando(false);
        }
    };

    return (
        <div className={styles.avatarWrapper}>
            <button className={styles.empresaSection} onClick={() => setAberto((v) => !v)} title="Trocar de empresa">
                <div className={styles.filialInfo}>
                    <span className={styles.filialLabel}>Empresa</span>
                    <span className={styles.filialName} title={empresaAtiva?.name}>{empresaAtiva?.name ?? 'Selecionar'}</span>
                </div>
                <FiChevronDown className={styles.filialChevron} />
            </button>

            {aberto && (
                <>
                    <div className={styles.backdrop} onClick={fechar} />
                    <div className={`${styles.dropdown} ${styles.empresaDropdown}`}>
                        {empresas.map((empresa) => (
                            <button
                                key={empresa.id}
                                className={styles.dropdownItem}
                                onClick={() => {
                                    fechar();
                                    if (empresa.id !== empresaAtiva?.id) selecionarEmpresa(empresa.id);
                                }}
                            >
                                {empresa.souDono ? <FiHome size={15} /> : <span className={styles.empresaMarcador} />}
                                <span className={styles.empresaNome}>
                                    {empresa.name}
                                    <span className={styles.empresaDetalhe}>
                                        {empresa.souDono ? 'Sua empresa' : 'Convidado'}
                                        {empresa.estado !== 'liberada' && ` · ${ROTULO_DO_ESTADO[empresa.estado]}`}
                                    </span>
                                </span>
                                {empresa.id === empresaAtiva?.id && <FiCheck size={15} className={styles.empresaCheck} />}
                            </button>
                        ))}

                        {!temPropria && (
                            confirmandoCriacao ? (
                                <div className={styles.empresaConfirmacao}>
                                    <p>
                                        Sua empresa nasce {user?.planId ? 'no seu plano atual' : 'no plano gratuito'}, separada
                                        das empresas em que você foi convidado.
                                    </p>
                                    <button className={styles.empresaCriarBtn} onClick={criar} disabled={criando}>
                                        {criando ? 'Criando...' : 'Criar minha empresa'}
                                    </button>
                                </div>
                            ) : (
                                <button className={styles.dropdownItem} onClick={() => setConfirmandoCriacao(true)}>
                                    <FiPlus size={15} />
                                    Criar minha empresa
                                </button>
                            )
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
